import React, {Suspense} from 'react';
import dynamic from 'next/dynamic';
import {ArticleHeroBlockConstants} from '../../adapters/helpers/Constants'
import Block from '../../adapters/helpers/Block';
import PropTypes from 'prop-types'
import {Label} from '../Label/Label';
import { mediaQueryHOC } from '../../adapters/helpers/Hooks';
import Loader from '../../adapters/helpers/Loader';

const Heading = dynamic(() => import('../Heading/Heading'));
import DOMPurify from 'isomorphic-dompurify';
const Image = dynamic(() => import('../Image/Image'));
const Disclaimer = dynamic(() => import('../Disclaimer/Disclaimer'));
function LegacyArticleHeroBlock(props) {
    const block = new Block(props);
    const { extraAttributes, isMedium,isSmall } = props;
    const className = block.getFieldValue('classNames');
    const anchorId = block.getAnchorId();
    const showImage = extraAttributes?.entity?.articleOverview?.fields?.showImage;    
    const thumbnailImage = extraAttributes?.entity?.articleOverview?.fields?.thumbnailImage;
    const mobileImage = block.getFieldValue('mobileBackgroundAsset');
    const title = extraAttributes?.entity?.articleOverview?.fields?.title;
    const eyebrow = extraAttributes?.entity?.category?.fields?.title;
    const slug = extraAttributes?.entity?.category?.fields?.slug?.fields?.slug;
    const readingTimeLabel = Label({label: block.getFieldValue(ArticleHeroBlockConstants.readTimeLabel), tokens: {readTime: extraAttributes.entity.articleOverview.fields.readTime}});
    const body = extraAttributes?.entity?.articleOverview?.fields?.description;
    const backgroundAsset = extraAttributes?.entity?.backgroundAsset;
    const disclaimer = block?.fields?.disclaimer;
    const renderImage = () => {
        return (
            <Suspense fallback={<Loader />}>
            <div className="ob-mini-content-image-container">
                    <Image
                        className={
                            isSmall
                                ? 'ob-mini-content-mobile-image'
                                : 'ob-mini-content-dektop-image'
                        }
                        image={isSmall ? backgroundAsset : backgroundAsset}
                    />
            </div>
            </Suspense>
        );
    };
    const renderText = () => {
        return (
            <Suspense fallback={<Loader />}>
            <div
                className='ob-mini-content-text-area-wrapper'
            >
                {eyebrow && (
                    <p
                        className='ob-mini-content-eyebrow'
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(eyebrow) }}
                    />
                )}
                {title && (
                    <h1
                        className='ob-mini-content-header'
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
                    />
                )}
            </div>
            </Suspense>
        );
    };
    return (
        <>
            <div className={`ob-mini-content-block ${className ? className : ''}`} id={anchorId}>
                {renderImage()}
                {renderText()}
            </div>
        </>
    );
}
export default mediaQueryHOC(LegacyArticleHeroBlock);
LegacyArticleHeroBlock.propTypes = {
    extraAttributes: PropTypes.object
};
